import React from 'react'
import { Text, Box } from 'grommet'

import moment from 'moment'

const Time = ({
  position = 'left',
  currentMessage = { createdAt: null },
  timeTextStyle = {}
}) => {
  return (
    <Box>
      <Text style={timeTextStyle[position]}>
        {moment(currentMessage.createdAt).format('LT')}
      </Text>
    </Box>
  )
}

export default Time
